import { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';

// Turns a quote request (Inquiry) into a marketplace lead (ForSale).
// Injuries already on the inquiry carry over; admin just sets accident type and price.
export function ConvertLeadModal({ lead, show, onHide, idToken, onConverted }) {
  const [accidentTypes, setAccidentTypes] = useState([]);
  const [accidentTypeId, setAccidentTypeId] = useState('');
  const [price, setPrice] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!show) return;
    axios.get(`${process.env.REACT_APP_CORE_API}/accidenttype`)
      .then(res => setAccidentTypes(res.data || []))
      .catch(err => console.error('Failed to load accident types:', err));
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_CORE_API}/lead/${lead.id}`,
        { status: 'ForSale', accidentTypeId, price: parseFloat(price) },
        { headers: { Authorization: idToken } }
      );
      setAccidentTypeId('');
      setPrice('');
      onConverted?.(lead.id);
      onHide();
    } catch (err) {
      setError(err.response?.data?.detail || err.response?.data || 'Failed to post lead');
    } finally {
      setSubmitting(false);
    }
  };

  if (!lead) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Post to Marketplace</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted mb-3">
            <strong>{lead.firstName} {lead.lastName}</strong> · {lead.state}
            {lead.injuries?.length > 0 && (
              <> · {lead.injuries.map(i => i.bodyPart).join(', ')}</>
            )}
          </p>
          {lead.injuries?.length === 0 && (
            <div className="alert alert-warning small">
              This request has no injuries recorded. You can add them from the marketplace after posting.
            </div>
          )}
          {error && <div className="alert alert-danger small">{error}</div>}
          <Row>
            <Col md={7}>
              <Form.Group className="mb-3">
                <Form.Label>Accident Type</Form.Label>
                <Form.Select value={accidentTypeId} onChange={(e) => setAccidentTypeId(e.target.value)} required>
                  <option value="">Select...</option>
                  {accidentTypes.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={5}>
              <Form.Group className="mb-3">
                <Form.Label>Price ($)</Form.Label>
                <Form.Control type="number" min="1" step="1" placeholder="e.g. 500" value={price} onChange={(e) => setPrice(e.target.value)} required />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Cancel</Button>
          <Button type="submit" disabled={submitting || !accidentTypeId || !price}>
            {submitting ? 'Posting...' : 'Post Lead'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
